import React, { useEffect, useState } from 'react';
import { translate } from '../../services/translate';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { accessService } from '../../services/central-api/access';

interface Props {
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
    zIndex: number;
}

function TagsDropdown({ value, setValue, zIndex }: Props) {
    const [selectableTags, setSelectableTags] = useState<{ label: string; value: number; }[]>([]);

    async function loadTags() {
        try {
            const tags = await accessService.getUserTags();
            if (!tags) {
                setSelectableTags([]);
            } else {
                setSelectableTags(tags.map((tag) => {
                    return {
                        value: tag.id || 0,
                        label: tag.name
                    };
                }));
            }
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        loadTags();
    }, []);

    return (
        <FilterDropdown
            label={translate('tags')}
            items={selectableTags}
            multiple={true}
            mode='BADGE'
            setValue={setValue}
            value={value}
            zIndex={zIndex}
        />
    );
}

export default TagsDropdown;
